module.exports = __webpack_public_path__ + "static/media/S1N4.641bec39.svg";